import { ConditionalValue, ProgressCircle } from "@chakra-ui/react";

interface Props {
  size?: ConditionalValue<"xs" | "sm" | "md" | "lg" | "xl" | undefined>;
}

export const ProgressCircleComponent = ({ size = "sm" }: Props) => {
  return (
    <ProgressCircle.Root
      value={null}
      size={size}
      data-testid="progress-circle-component"
    >
      <ProgressCircle.Circle>
        <ProgressCircle.Track />
        <ProgressCircle.Range />
      </ProgressCircle.Circle>
    </ProgressCircle.Root>
  );
};
